import { useState } from "react";
import { Check } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { SIGNUP } from "@/constants/testIds";

const input = "w-full px-5 py-3.5 rounded-full bg-white text-[#1C1917] border border-[#E7E0D3] focus:outline-none focus:ring-2 focus:ring-[#E06D44]/40";

export const SignupForm = ({ source, cta, withPhone = false }) => {
  const { setCode } = useCart();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [state, setState] = useState({});

  const submit = async (e) => {
    e.preventDefault();
    setState({ busy: true });
    try {
      const { data } = await api.post("/signup", { email, phone: phone || null, source, ref: localStorage.getItem("pettok_ref") });
      setCode(data.code);
      setState({ code: data.code, guide: data.guide });
    } catch (err) {
      setState({ error: errMsg(err) });
    }
  };

  if (state.code)
    return (
      <div data-testid={SIGNUP.success(source)} className="flex items-start gap-3 bg-white/10 rounded-3xl p-5">
        <Check className="text-[#6EE7B7] shrink-0" />
        <p>
          You're in! Your code <span className="font-bold tracking-wider">{state.code}</span> gives you 10% off your first order. We've added it to your cart.
          {state.guide === "sent" && " Your guide is on its way to your inbox."}
          {state.guide === "already" && " You're already on the list, so check your inbox for the guide we sent earlier."}
          {state.guide === "failed" && " We couldn't send your guide just now. Please try again in a minute."}
          {state.guide === "limited" && " We've had a lot of guide requests from your connection. Please try again in an hour."}
        </p>
      </div>
    );

  return (
    <form onSubmit={submit} className="space-y-3">
      <input data-testid={SIGNUP.emailInput(source)} required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com" className={input} />
      {withPhone && <input data-testid={SIGNUP.phoneInput(source)} type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone (optional, for drop alerts)" className={input} />}
      <button data-testid={SIGNUP.submit(source)} disabled={state.busy} className="w-full py-3.5 rounded-full bg-[#E06D44] text-white font-medium hover:bg-[#C95B33] disabled:opacity-60 transition-colors">{cta}</button>
      {state.error && <p className="text-sm text-[#FCA5A5]">{state.error}</p>}
    </form>
  );
};
